/*
 * @Description:wx 工具集
 * @Author: fiveonelei
 * @Date: 2022-01-19 17:00:28
 * @FilePath: /vise/packages/app-share/src/utils/wx.ts
 */
import { loadWslWxAsync } from '@/utils/load-wslib';
import { Opts } from '@tencent/wsl-wx';

enum EWxConfigStatus {
  success = 'success',
  loading = 'loading',
  fail = 'fail',
  none = 'none'
}

let wxConfigStatus: EWxConfigStatus = EWxConfigStatus.none;

export const initWXConf = async (opt: Opts) => {
  if (wxConfigStatus === EWxConfigStatus.success || wxConfigStatus === EWxConfigStatus.loading) {
    return;
  };
  if (typeof window === undefined) return null;
  try {
    wxConfigStatus = EWxConfigStatus.loading;
    const wx = await loadWslWxAsync();
    if (!wx) {
      wxConfigStatus = EWxConfigStatus.fail;
      return null;
    }
    await wx.initWXConf(opt);
    if (!window.wx) {
      wxConfigStatus = EWxConfigStatus.fail;
      return null;
    }
    wxConfigStatus = EWxConfigStatus.success;
    console.log('miniprogram init success');
    return window.wx;
  } catch (err) {
    wxConfigStatus = EWxConfigStatus.fail;
    console.log('miniprogram init fail');
  };
};

